function getWholesalePrice(variant) {
  if (!variant) {
    return 0;
  }

  const b2b = Number(
    variant?.b2b_price || variant?.metafields?.custom?.b2b_price || 0,
  );
  if (b2b > 0) {
    return b2b;
  }

  const price = variant?.price ?? 0;
  if (price === 0) {
    return 0;
  }
  return price / 100;
}

const getPriceBSSB2B = (originProduct, productId, variantId) => {
  let product = JSON.parse(JSON.stringify(originProduct));
  const targetVariant = product.variants.find((v) => v.id === variantId);
  if (!targetVariant) {
    console.error("Variant not found", variantId);
    return 0;
  }
  return getWholesalePrice(targetVariant);
};

//Fgc support, update product detail price when selecting variant
(function () {
  //For bss b2b price update
  const GST_RATE = 1.1;
  document.addEventListener("DOMContentLoaded", function () {
    // Cache DOM elements
    const optionInputs = document.querySelectorAll(
      "input[data-single-option-selector]",
    );
    const hiddenVariantInput = document.querySelector('input[name="id"]');
    const variants = window.productVariants || [];
    const rrpValueElement = document.getElementById("rrp-value");
    const wholesalePriceElement = document.getElementById(
      "wholesale-price-value",
    );
    const skuElement = document.querySelector(".product__sku");
    const addToCartRRPPriceText = document.querySelector(
      "#rrp-price-add-to-cart",
    );
    let addToCartWholesalePriceText;
    if (!addToCartRRPPriceText) {
      addToCartWholesalePriceText = document.querySelector(
        "#wholesale-price-add-to-cart",
      );
    } else {
      if (window.is_wholesale == "yes") {
        addToCartRRPPriceText.style.display = "none";
      }
    }
    const currency = window.shopCurrency || "AUD";

    // Create price formatter once
    const formatter = new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency,
      currencyDisplay: "symbol",
      minimumFractionDigits: 2,
    });

    // Function to round price to the nearest integer (cent)
    function roundPrice(price) {
      return price;
      // return price % 1 >= 0.5 ? Math.ceil(price) : Math.floor(price);
    }

    function formatPrice(price) {
      // Round before formatting
      return formatter.format(roundPrice(price)).replace("A$", "$");
    }

    function getRRPPrice(variant) {
      if (!variant || !variant.price) {
        return 0;
      }
      return variant.price / 100;
    }

    function updateRRPPrice(variant) {
      if (!rrpValueElement || !variant) return;
      rrpValueElement.textContent = formatPrice(
        getRRPPrice(variant) * GST_RATE,
      );
    }

    function updateWholesalePrice(variant) {
      if (!wholesalePriceElement) return;
      const wholesalePriceGroup = document.getElementById(
        "wholesale-price-group",
      );
      if (wholesalePriceGroup) {
        wholesalePriceElement.textContent = formatPrice(
          getWholesalePrice(variant),
        );
      }
    }

    function getProductTypeFromJSON() {
      // Method 1: Try to get from data-product-json script tag
      const productJsonScript = document.querySelector(
        "script[data-product-json]",
      );
      if (productJsonScript) {
        try {
          const productData = JSON.parse(productJsonScript.textContent);
          return productData.type;
        } catch (e) {
          console.error("Failed to parse product JSON:", e);
        }
      }

      // Method 2: Try to get from window.product object (if theme sets it)
      if (window.product && window.product.type) {
        return window.product.type;
      }

      return null;
    }

    // ============================================
    // SHARED SKU UPDATE LOGIC (eliminates duplication)
    // ============================================
    function updateSkuDisplay(variant) {
      if (!skuElement) return;
      if (!variant?.sku) {
        skuElement.textContent = "";
        skuElement.classList.remove("sku-positioned");
        return;
      }

      const productType = getProductTypeFromJSON().toLowerCase().trim();

      // Special handling for Wallpaper and Mirrors - keep "SKU:" format
      if (productType.includes("wallpaper") || productType.includes("mirror")) {
        skuElement.textContent = `SKU: ${variant.sku}`;
      } else {
        // Build SKU display with suffix
        const skuDisplay = ` | ${variant.sku}`;
        skuElement.textContent = skuDisplay;
      }

      // Update position after content change
      positionSkuNextToSuffix();
    }

    // ============================================
    // SKU POSITIONING - Place SKU next to suffix
    // ============================================

    // Helper function to reset all positioning styles
    function resetSkuPositioning(sku) {
      const positioningProps = [
        "position",
        "left",
        "top",
        "right",
        "bottom",
        "display",
        "marginTop",
      ];
      positioningProps.forEach((prop) => (sku.style[prop] = ""));
    }

    function positionSkuNextToSuffix() {
      const suffix = document.querySelector(".product-title-suffix");
      const sku = document.querySelector(".product__sku");

      if (!sku) return;

      if (!suffix) {
        // No suffix - use static positioning as fallback
        sku.classList.add("sku-positioned");
        resetSkuPositioning(sku);
        sku.style.position = "static";
        return;
      }

      // Mobile viewport check: prevent overflow on narrow screens
      const isMobile = window.innerWidth <= 749;
      const containerWidth =
        sku.closest(".product__content")?.offsetWidth || window.innerWidth;
      const suffixWidth = suffix.offsetWidth;
      const estimatedSkuWidth = sku.textContent.length * 7; // rough estimate in px
      const spacing = 3;
      const requiredWidth = suffixWidth + estimatedSkuWidth + spacing;

      // If total width exceeds 85% of container on mobile, use static layout
      if (isMobile && requiredWidth > containerWidth * 0.85) {
        sku.classList.add("sku-positioned");
        resetSkuPositioning(sku);
        sku.style.position = "static";
        sku.style.display = "block";
        sku.style.marginTop = "4px";
        console.debug(
          "SKU positioning: Using static layout due to width constraints",
          {
            requiredWidth,
            containerWidth,
            isMobile,
          },
        );
        return;
      }

      try {
        // Get offsetParent and dimensions
        const offsetParent = suffix.offsetParent;
        if (!offsetParent) {
          console.warn("SKU Positioning: No offsetParent found for suffix");
          sku.classList.add("sku-positioned");
          resetSkuPositioning(sku);
          sku.style.position = "static";
          return;
        }

        // Simple calculation using offset properties
        const suffixOffsetLeft = suffix.offsetLeft;
        const suffixOffsetTop = suffix.offsetTop;

        // SKU position = suffix left + suffix width + spacing
        const leftPosition = suffixOffsetLeft + suffixWidth + spacing;
        const topPosition = suffixOffsetTop;

        // Make sure offsetParent can serve as positioning context
        const computedStyle = window.getComputedStyle(offsetParent);
        if (computedStyle.position === "static") {
          offsetParent.style.position = "relative";
        }

        // Apply positioning to SKU
        sku.style.position = "absolute";
        sku.style.left = `${leftPosition}px`;
        sku.style.top = `${topPosition}px`;
        // Reset any inline display/margin changes from previous static fallback
        sku.style.display = "";
        sku.style.marginTop = "";

        // Mark as positioned to make visible
        sku.classList.add("sku-positioned");

        console.debug("SKU positioned:", {
          left: leftPosition,
          top: topPosition,
          suffixOffsetLeft,
          suffixWidth,
          offsetParent: offsetParent.tagName,
        });
      } catch (error) {
        console.error("SKU positioning error:", error);
        // Fallback to static positioning on error
        sku.classList.add("sku-positioned");
        resetSkuPositioning(sku);
        sku.style.position = "static";
      }
    }

    function updateVariantURLAndInput() {
      const optionInputs = document.querySelectorAll(
        "input[data-single-option-selector]",
      );
      const selectedOptions = Array.from(optionInputs)
        .sort((a, b) => a.dataset.index.localeCompare(b.dataset.index))
        .map((input) => input.value.trim());

      const matchedVariant = variants.find((variant) =>
        variant.title
          .split(" / ")
          .every((opt, i) => opt.trim() === selectedOptions[i]),
      );
      if (!matchedVariant) return;

      // Update URL
      window.history.replaceState(
        {},
        "",
        `${window.location.pathname}?variant=${matchedVariant.id}`,
      );

      // Update form
      if (hiddenVariantInput) {
        hiddenVariantInput.value = matchedVariant.id;
      }

      // Update SKU using shared function
      updateSkuDisplay(matchedVariant);

      // Update price text
      if (addToCartRRPPriceText && matchedVariant.price) {
        addToCartRRPPriceText.innerHTML = `&nbsp;(${formatPrice(
          // Multiply by 1.1 for B2C customers
          getRRPPrice(matchedVariant) * GST_RATE,
        )})`;
        addToCartRRPPriceText.style.display = "block";
      }
      // Update prices
      updateRRPPrice(matchedVariant);
      updateWholesalePrice(matchedVariant);
      // Display wholesale price on add to cart button for B2B customers
      // https://app.clickup.com/t/86czg0tet
      if (addToCartWholesalePriceText) {
        setTimeout(() => {
          let wholesalePrice = 0;
          if (matchedVariant.b2b_price && !isNaN(matchedVariant.b2b_price)) {
            wholesalePrice = parseFloat(matchedVariant.b2b_price);
          } else if (matchedVariant.price) {
            wholesalePrice = matchedVariant.price / 100;
          }
          addToCartWholesalePriceText.innerHTML = `&nbsp;(${formatPrice(
            wholesalePrice,
          )})`;
          //remove the strikethrough price on product details page and show percentage discount
          // For task: https://app.clickup.com/t/86czg3ckj
          const wholesaleSaveLabel = document.getElementById(
            "wholesale-save-label",
          );
          wholesalePrice = getWholesalePrice(matchedVariant);
          const rrpPrice = getRRPPrice(matchedVariant);
          if (wholesaleSaveLabel && wholesalePriceElement) {
            if (rrpPrice > 0 && wholesalePrice > 0) {
              const discountPercent = Math.round(
                ((rrpPrice - wholesalePrice) / rrpPrice) * 100,
              );
              wholesaleSaveLabel.innerHTML = `save ${discountPercent}%`;
            } else {
              wholesaleSaveLabel.innerHTML = "";
            }
          } else {
            wholesaleSaveLabel.innerHTML = "";
          }
          let customPriceInput = document.querySelector(
            "input[name='properties[_b2b_price_matefield]']",
          );
          if (!customPriceInput) {
            customPriceInput = document.createElement("input");
            customPriceInput.type = "hidden";
            customPriceInput.name = "properties[_b2b_price_matefield]";
            addToCartForm.appendChild(customPriceInput);
          }
          let newPrice = 0;
          if (window.is_wholesale == "yes") {
            newPrice = getWholesalePrice(matchedVariant);
          }
          customPriceInput.value = newPrice;
        }, 300);
      }
    }

    // Add inpunt hidden to add_to_cart_form when change variant
    function handleAddToCartPriceChange(e) {
      // Get current variants
      const selectedOptions = Array.from(optionInputs)
        .sort((a, b) => a.dataset.index.localeCompare(b.dataset.index))
        .map((input) => input.value.trim());

      const matchedVariant = variants.find((variant) =>
        variant.title
          .split(" / ")
          .every((opt, i) => opt.trim() === selectedOptions[i]),
      );

      if (!matchedVariant) return;

      // Find form add to cart
      const addToCartForm = e.target.closest("form[action*='/cart/add']");
      if (addToCartForm) {
        // Find the price input if it exists, or create a new hidden input to submit the new price
        let customPriceInput = addToCartForm.querySelector(
          "input[name='properties[_b2b_price_matefield]']",
        );
        if (!customPriceInput) {
          customPriceInput = document.createElement("input");
          customPriceInput.type = "hidden";
          customPriceInput.name = "properties[_b2b_price_matefield]";
          addToCartForm.appendChild(customPriceInput);
        }
        let newPrice = 0;
        if (window.is_wholesale == "yes") {
          newPrice = getWholesalePrice(matchedVariant);
        }
        customPriceInput.value = newPrice;
      }
    }

    // Add event listeners
    optionInputs.forEach((input) =>
      input.addEventListener("change", updateVariantURLAndInput),
    );

    document.addEventListener("change", (e) => {
      if (e.target.matches("input[data-single-option-selector]")) {
        updateVariantURLAndInput();
      }
    });

    // Add event listener for add to cart button
    /* document.addEventListener("click", function (e) {
      if (
        e.target.matches("button[type='submit'][name='add']") ||
        e.target.closest("button[type='submit'][name='add']")
      ) {
        handleAddToCartPriceChange(e);
      }
    });*/

    // Initial update
    updateVariantURLAndInput();

    // ============================================
    // FIX: Override theme.js SKU update using capture phase
    // ============================================
    // Theme.js dispatches 'theme:variant:change' event AFTER overwriting SKU
    // We use capture phase (true) to run BEFORE theme.js's listeners
    // This prevents theme.js updateSku() from overwriting our custom format
    document.addEventListener(
      "theme:variant:change",
      (event) => {
        const variant = variants.find((v) => v.id === event.detail.variant.id);
        if (variant) {
          updateSkuDisplay(variant);
        }
      },
      true,
    ); // Use capture phase to run before theme.js

    // One-time override for initial page load
    // Theme.js may overwrite during initialization
    setTimeout(() => {
      const currentVariant = variants.find(
        (v) => v.id === hiddenVariantInput?.value,
      );
      if (currentVariant) {
        updateSkuDisplay(currentVariant);
      }
    }, 100);

    // ============================================
    // WINDOW EVENT LISTENERS for SKU positioning
    // ============================================
    let skuPositionTimeout;

    // Debounced position update on window resize
    window.addEventListener("resize", () => {
      clearTimeout(skuPositionTimeout);
      skuPositionTimeout = setTimeout(() => {
        positionSkuNextToSuffix();
      }, 100);
    });

    // Update position after images load (layout may shift)
    window.addEventListener("load", () => {
      setTimeout(() => {
        positionSkuNextToSuffix();
      }, 200);
    });
  });
})();

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".fgc-enquire-cover").forEach(function (coverEl) {
    coverEl.addEventListener("click", function (e) {
      e.preventDefault();

      document.querySelectorAll(".fgc-enquire-root").forEach(function (rootEl) {
        rootEl.click();
      });
    });
  });
});

document.addEventListener("click", function (e) {
  const trigger = e.target.closest(
    'a[href="#enquire-button"], .enquire-link, [data-enquire-open]',
  );
  if (!trigger) return;

  e.preventDefault();

  const modalRoot = document.querySelector(".fgc-product-soldout-notification");
  if (!modalRoot) return;

  modalRoot.removeAttribute("hidden");

  const openBtn = modalRoot.querySelector("[data-popup-open]");
  if (openBtn) openBtn.click();
});

(function () {
  function getParam(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

  function tryOpen() {
    var btn =
      document.getElementById("enquire-button") ||
      document.querySelector(".fgc-enquire-root,[data-popup-open]");

    if (btn) {
      btn.click();
      return true;
    }
    return false;
  }

  function whenReady(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  whenReady(function () {
    var shouldOpen =
      getParam("enquiry") === "1" ||
      getParam("enquire") === "1" ||
      window.location.hash === "#enquire-button";

    if (!shouldOpen) return;

    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (tryOpen() || tries > 30) clearInterval(timer);
    }, 100);
  });
})();

// Format telephone input to Australian format on blur and form submit, task VIP signup
document.addEventListener("DOMContentLoaded", function () {
  const telInput = document.querySelector("input[name='customer[telephone]']");

  const toAU = (v) => {
    let d = (v || "").replace(/[^\d]/g, "");
    if (!d) return "";
    if (d.startsWith("0")) d = "61" + d.slice(1);
    else if (!d.startsWith("61")) d = "61" + d;
    return "+" + d;
  };

  if (telInput) {
    telInput.addEventListener("blur", () => {
      telInput.value = toAU(telInput.value);
    });

    form.addEventListener("submit", () => {
      telInput.value = toAU(telInput.value);
    });
  }
});

// Show wishlist icon on wallpaper collection and search pages
// Consolidated selectors for wallpaper product grid items
const WALLPAPER_GRID_SELECTORS = [
  ".template-collection.template__wallpaper .cc-grid-item.product-item--swatches",
  ".template-collection .cc-grid-item.product-item--swatches",
  ".template-search .cc-grid-item.product-item--swatches",
  ".template-search .cc-grid-item.product-item",
  ".search-page .cc-grid-item.product-item--swatches",
  ".search-page .cc-grid-item.product-item",
];

function updateSwymPosition() {
  if (window.matchMedia("(max-width: 1100px)").matches) {
    // Mobile positioning - use shared selector constant
    WALLPAPER_GRID_SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (parent) {
        const children = parent.children;
        if (children.length < 3) return;

        const child2 = children[1];
        const swym = parent.querySelector(
          ".swym-wishlist-collections-v2-container",
        );
        if (!child2 || !swym) return;

        const child2Top = child2.offsetTop;

        swym.style.position = "absolute";
        swym.style.top = child2Top + "px";
      });
    });
  } else {
    // Desktop positioning - place wishlist button at bottom of image
    // Use shared selector constant
    WALLPAPER_GRID_SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (parent) {
        const children = parent.children;
        if (children.length < 2) return;

        const child1 = children[0]; // Hình ảnh (anh cả)
        const swym = parent.querySelector(
          ".swym-wishlist-collections-v2-container",
        );
        if (!child1 || !swym) return;

        const child1Height = child1.offsetHeight;
        const swymHeight = swym.offsetHeight;
        const topValue = child1Height - swymHeight;

        swym.style.position = "absolute";
        swym.style.top = topValue + "px";
        swym.style.bottom = "auto";
      });
    });
  }
}

// Đợi cả DOM, images, và Swym load xong
document.addEventListener("DOMContentLoaded", function () {
  updateSwymPosition();
  // Chạy lại sau khi images load xong
  window.addEventListener("load", updateSwymPosition);
});
window.addEventListener("resize", updateSwymPosition);

// Theo dõi khi Swym elements được thêm vào DOM
function observeSwymElements() {
  const observer = new MutationObserver(function (mutations) {
    let shouldUpdate = false;
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (
          node.nodeType === 1 &&
          (node.classList?.contains("swym-wishlist-collections-v2-container") ||
            node.querySelector?.(".swym-wishlist-collections-v2-container"))
        ) {
          shouldUpdate = true;
        }
      });
    });
    if (shouldUpdate) {
      updateSwymPosition();
    }
  });

  // Observe both collection and search page wallpaper items
  // Use shared selector constant for consistency
  WALLPAPER_GRID_SELECTORS.forEach(function (selector) {
    document.querySelectorAll(selector).forEach(function (gridItem) {
      observer.observe(gridItem, { childList: true, subtree: true });
    });
  });
}

document.addEventListener("DOMContentLoaded", observeSwymElements);

/**
 * Wallpaper Room Image Replacement for Recently Viewed Products
 * Thay thế hover images bằng room images cho wallpaper products trong Recently Viewed tab
 */
(function () {
  "use strict";

  // Track processed products to prevent duplicate processing
  const processedProducts = new WeakSet();
  let isProcessing = false;
  let pendingProcess = false;

  // Cache for image existence checks to avoid duplicate requests
  const imageExistsCache = new Map();

  /**
   * Kiểm tra ảnh có tồn tại thực sự không
   * @param {string} imageUrl - URL của ảnh cần kiểm tra
   * @param {number} timeout - Timeout in milliseconds (default: 5000ms)
   * @returns {Promise<boolean>} - true nếu ảnh tồn tại, false nếu không hoặc timeout
   */
  const checkImageExists = (imageUrl, timeout = 5000) => {
    // Return cached result if available
    if (imageExistsCache.has(imageUrl)) {
      return Promise.resolve(imageExistsCache.get(imageUrl));
    }

    return new Promise((resolve) => {
      if (!imageUrl) {
        resolve(false);
        return;
      }

      let timeoutId;
      const img = new Image();

      // Explicitly request CORS access for reliability
      img.crossOrigin = "anonymous";

      img.onload = () => {
        clearTimeout(timeoutId);
        imageExistsCache.set(imageUrl, true);
        resolve(true);
      };

      img.onerror = () => {
        clearTimeout(timeoutId);
        imageExistsCache.set(imageUrl, false);
        resolve(false);
      };

      // Timeout safety net
      timeoutId = setTimeout(() => {
        imageExistsCache.set(imageUrl, false);
        resolve(false);
      }, timeout);

      img.src = imageUrl;
    });
  };

  /**
   * Tìm room image từ TẤT CẢ các màu, với fallback
   * Ưu tiên: màu đầu tiên → màu tiếp theo → null nếu không có
   * @param {Array} colorImages - Mảng các màu với images
   * @returns {Object|null} - Room image object hoặc null
   */
  const findRoomImageFromAllColors = (colorImages) => {
    if (
      !colorImages ||
      !Array.isArray(colorImages) ||
      colorImages.length === 0
    ) {
      return null;
    }

    // Duyệt qua từng màu để tìm room image
    for (let i = 0; i < colorImages.length; i++) {
      const colorData = colorImages[i];
      if (!colorData.images || !Array.isArray(colorData.images)) continue;

      const roomImage = colorData.images.find((img) => img.type === "room");

      if (roomImage && roomImage.url) {
        return roomImage;
      }
    }

    return null;
  };

  /**
   * Helper function to replace wallpaper hover images with room images
   * ONLY processes products within .tabs__recently-viewed containers
   * Có fallback qua các màu khác và kiểm tra ảnh tồn tại
   */
  const replaceWallpaperRoomImages = (productItems) => {
    if (!productItems || productItems.length === 0) return Promise.resolve();

    let processedCount = 0;
    let replacedCount = 0;

    // Xử lý async với Promise.all
    const promises = Array.from(productItems).map((productItem) => {
      return new Promise((resolve) => {
        try {
          // CRITICAL: Chỉ xử lý products trong .tabs__recently-viewed container
          const recentlyViewedContainer = productItem.closest(
            ".tabs__recently-viewed",
          );
          if (!recentlyViewedContainer) {
            resolve();
            return;
          }

          // Tìm JSON data script cho product này
          const jsonDataScript = productItem.querySelector(
            '.color-images-json[type="application/json"]',
          );
          if (!jsonDataScript) {
            resolve();
            return;
          }

          // Parse color_images JSON
          let colorImages;
          try {
            colorImages = JSON.parse(jsonDataScript.textContent);
          } catch (e) {
            resolve();
            return;
          }

          // Validate data structure
          if (
            !colorImages ||
            !Array.isArray(colorImages) ||
            colorImages.length === 0
          ) {
            resolve();
            return;
          }

          processedCount++;

          // Tìm room image từ TẤT CẢ các màu (có fallback)
          const roomImage = findRoomImageFromAllColors(colorImages);
          if (!roomImage || !roomImage.url) {
            resolve();
            return;
          }

          // Tìm tất cả data-hover-slide elements trong product-item này
          const hoverSlides =
            productItem.querySelectorAll("[data-hover-slide]");
          if (hoverSlides.length === 0) {
            resolve();
            return;
          }

          // Kiểm tra ảnh có tồn tại không trước khi replace
          checkImageExists(roomImage.url).then((exists) => {
            if (!exists) {
              resolve();
              return;
            }

            // Thay thế ảnh trong mỗi hover slide
            hoverSlides.forEach((slide) => {
              const imgElement = slide.querySelector("img");
              if (!imgElement) return;

              // Update src để sử dụng room image
              imgElement.src = roomImage.url;

              // Clear srcset và sizes để tránh xung đột
              imgElement.removeAttribute("srcset");
              imgElement.removeAttribute("sizes");

              // Mark as replaced cho debugging
              imgElement.setAttribute("data-wallpaper-room-replaced", "true");
              replacedCount++;
            });

            resolve();
          });
        } catch (error) {
          resolve();
        }
      });
    });

    // Đợi tất cả promises hoàn thành rồi log summary
    return Promise.all(promises).then(() => {
      if (replacedCount > 0) {
        console.log(
          "✅ Replaced " +
            replacedCount +
            " wallpaper room images in recently viewed",
        );
      }
    });
  };

  /**
   * Process wallpaper products trong recently viewed tab
   */
  const processWallpaperProductsInRecentlyViewed = () => {
    const recentlyViewedContainer = document.querySelector(
      ".tabs__recently-viewed",
    );
    if (!recentlyViewedContainer) return;

    // Filter to only process products not yet processed
    const productItems = Array.from(
      recentlyViewedContainer.querySelectorAll(".product-item"),
    ).filter((item) => !processedProducts.has(item));

    if (productItems.length === 0) {
      return;
    }

    // Mark as processed BEFORE async work to prevent race conditions
    productItems.forEach((item) => processedProducts.add(item));

    replaceWallpaperRoomImages(productItems);
  };

  /**
   * Debounced process function to prevent race conditions
   */
  const scheduleProcessing = () => {
    if (isProcessing) {
      pendingProcess = true;
      return;
    }

    isProcessing = true;

    setTimeout(() => {
      processWallpaperProductsInRecentlyViewed();
      isProcessing = false;

      if (pendingProcess) {
        pendingProcess = false;
        scheduleProcessing();
      }
    }, 100);
  };

  /**
   * MutationObserver để theo dõi khi products được thêm vào recently viewed
   */
  const observeRecentlyViewedTab = () => {
    const targetNode = document.querySelector(".tabs__recently-viewed");
    if (!targetNode) {
      // Retry sau 1s nếu chưa có
      setTimeout(observeRecentlyViewedTab, 1000);
      return;
    }

    const observer = new MutationObserver((mutations) => {
      let hasNewProducts = false;

      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            // Element node
            // Check nếu node là product-item hoặc chứa product-item
            if (node.classList && node.classList.contains("product-item")) {
              hasNewProducts = true;
            } else if (node.querySelectorAll) {
              const products = node.querySelectorAll(".product-item");
              if (products.length > 0) {
                hasNewProducts = true;
              }
            }
          }
        });
      });

      if (hasNewProducts) {
        // Use debounced processing to prevent race conditions
        scheduleProcessing();
      }
    });

    // Bắt đầu observe
    observer.observe(targetNode, {
      childList: true,
      subtree: true,
    });

    // Process ngay lập tức nếu đã có products
    scheduleProcessing();
  };

  // Bắt đầu observe khi DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observeRecentlyViewedTab);
  } else {
    observeRecentlyViewedTab();
  }

  // Also process khi có custom event từ theme
  document.addEventListener("theme:tab:check", () => {
    scheduleProcessing();
  });

  // Cleanup on page hide to prevent memory leaks
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
      imageExistsCache.clear();
    }
  });
})();

/**
 * Wallpaper Color Swatches - Change images based on selected color
 * Chức năng thay đổi hình ảnh khi người dùng chọn màu cho wallpaper products
 */
(function () {
  "use strict";

  // Track update functions for each product to enable updates after initialization
  const productUpdateFunctions = new Map();

  /**
   * Preload images để cache trong browser
   */
  const preloadImage = (url) => {
    if (!url) return;
    const img = new Image();
    img.src = url;
  };

  /**
   * Khởi tạo color swatches cho một product item
   */
  const initWallpaperSwatches = (productItem) => {
    const productId = productItem.getAttribute("data-product-id");
    if (!productId) {
      return;
    }

    // Skip if already initialized
    if (productUpdateFunctions.has(productItem)) {
      return;
    }

    // Find images - adjust selectors based on actual HTML structure
    const mainImage = productItem.querySelector(".product-item__bg img");
    const hoverSlides = productItem.querySelectorAll("[data-hover-slide] img");
    const jsonScript = productItem.querySelector(
      '.color-images-json[data-product-id="' + productId + '"]',
    );
    const colourInputs = productItem.querySelectorAll("[data-colour-selector]");

    if (!mainImage || !colourInputs.length || !jsonScript) {
      return;
    }

    // Parse JSON data
    let colourData = [];
    try {
      colourData = JSON.parse(jsonScript.textContent);
    } catch (e) {
      return;
    }

    /**
     * COMBINED: Gán attributes + preload priority images trong một loop
     * Tránh duplicate iteration và chỉ preload 4 màu đầu tiên
     */
    const initializeColorData = () => {
      const urlsToPreload = new Set();
      const MAX_COLORS_TO_PRELOAD = 4; // Chỉ preload 4 màu đầu tiên để tránh chậm page

      colourInputs.forEach((input, index) => {
        const colorValue = input.value.toLowerCase().trim();
        const matchedColor = colourData.find((c) => {
          return c.color.toLowerCase().trim() === colorValue;
        });

        if (matchedColor && matchedColor.images) {
          const roomImg = matchedColor.images.find((i) => i.type === "room");

          if (roomImg) {
            // Set attribute cho tất cả các màu
            input.setAttribute("data-color-image-room", roomImg.url);

            // Chỉ preload 4 màu đầu tiên
            if (index < MAX_COLORS_TO_PRELOAD) {
              urlsToPreload.add(roomImg.url);
            }
          }
        }

        // Preload variant image cho 4 màu đầu tiên
        if (index < MAX_COLORS_TO_PRELOAD) {
          const variantImage = input.getAttribute("data-variant-image");
          if (variantImage) {
            urlsToPreload.add(variantImage);
          }
        }
      });

      // Preload collected URLs
      urlsToPreload.forEach((url) => preloadImage(url));
      if (urlsToPreload.size > 0) {
        console.log(
          "🎯 Preloaded " +
            urlsToPreload.size +
            " priority images for product:",
          productId,
        );
      }
    };

    /**
     * Update images khi đổi màu - OPTIMIZED & FIXED
     */
    const updateImages = (selectedInput) => {
      const variantImage = selectedInput.getAttribute("data-variant-image");
      const roomImageUrl = selectedInput.getAttribute("data-color-image-room");

      // Update main image với attribute cleanup
      if (mainImage && variantImage) {
        mainImage.src = variantImage;
        // Cần remove srcset/sizes để tránh conflict với responsive images
        if (mainImage.hasAttribute("srcset")) {
          mainImage.removeAttribute("srcset");
        }
        if (mainImage.hasAttribute("sizes")) {
          mainImage.removeAttribute("sizes");
        }
      }

      // CHỈ UPDATE hover slide đầu tiên thay vì tất cả
      if (hoverSlides.length > 0) {
        const imageToUpdate = roomImageUrl || variantImage;
        const firstHoverSlide = hoverSlides[0];

        if (imageToUpdate && firstHoverSlide) {
          firstHoverSlide.src = imageToUpdate;
          // Cần remove srcset/sizes
          if (firstHoverSlide.hasAttribute("srcset")) {
            firstHoverSlide.removeAttribute("srcset");
          }
          if (firstHoverSlide.hasAttribute("sizes")) {
            firstHoverSlide.removeAttribute("sizes");
          }
        }
      }
    };

    // Initialize: gán attributes + preload priority colors
    initializeColorData();

    // Khởi tạo với màu đầu tiên (checked input)
    const checkedInput = productItem.querySelector(
      "[data-colour-selector]:checked",
    );
    if (checkedInput) {
      updateImages(checkedInput);
    }

    // Store the update function for this product
    productUpdateFunctions.set(productItem, updateImages);
  };

  /**
   * Process all wallpaper-related products in the DOM
   */
  const processWallpaperProducts = () => {
    const wallpaperProducts = document.querySelectorAll(
      ".product-item--swatches[data-product-id]",
    );
    if (wallpaperProducts.length === 0) {
      return;
    }
    wallpaperProducts.forEach((product) => initWallpaperSwatches(product));
  };

  /**
   * MutationObserver để theo dõi khi wallpaper products được thêm vào DOM
   *
   * NOTE: This is the SECOND MutationObserver in fgc-custom.js:
   * 1. Recently viewed observer (lines ~679-724) - processes products in .tabs__recently-viewed
   * 2. Wallpaper color swatches observer (here) - processes all .product-item--swatches
   *
   * They serve different purposes and cannot be easily consolidated because:
   * - Different target selectors (.tabs__recently-viewed vs .product-item--swatches)
   * - Different processing logic (image replacement vs color swatch initialization)
   * - Different optimization strategies (debouncing vs direct processing)
   */
  const observeWallpaperProducts = () => {
    // Process existing products immediately
    processWallpaperProducts();

    // Set up MutationObserver
    const observer = new MutationObserver((mutations) => {
      let hasNewProducts = false;

      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            // Element node
            // Check if the added node is a wallpaper product
            if (
              node.classList &&
              node.classList.contains("product-item--swatches")
            ) {
              hasNewProducts = true;
            }
            // Check if the added node contains wallpaper products
            else if (node.querySelectorAll) {
              const products = node.querySelectorAll(
                ".product-item--swatches[data-product-id]",
              );
              if (products.length > 0) {
                hasNewProducts = true;
              }
            }
          }
        });
      });

      if (hasNewProducts) {
        // Process new products
        processWallpaperProducts();
      }
    });

    // Observe the entire document for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  };

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observeWallpaperProducts);
  } else {
    observeWallpaperProducts();
  }

  /**
   * Event delegation for color swatch changes
   * Sử dụng event delegation để handle change events cho cả dynamically added elements
   */
  document.addEventListener("change", (e) => {
    const input = e.target.closest("[data-colour-selector]");
    if (!input) return;

    const productItem = input.closest(".product-item--swatches");
    if (!productItem) return;

    // Get the update function for this product
    const updateFunc = productUpdateFunctions.get(productItem);

    if (updateFunc) {
      // Call the stored update function directly
      updateFunc(input);
    } else {
      // Product not initialized yet, initialize it first
      initWallpaperSwatches(productItem);
      // Then call the update function
      const updateFuncAfterInit = productUpdateFunctions.get(productItem);
      if (updateFuncAfterInit) {
        updateFuncAfterInit(input);
      }
    }
  });
})();
